// Shared pill/rounded button styles (template-inspired, rounded edges)
export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 bg-rc-red text-white px-8 py-4 rounded-full font-bold uppercase tracking-[0.12em] text-sm hover:bg-rc-reddark transition-colors";

export const BTN_DARK =
  "inline-flex items-center justify-center gap-2 bg-rc-charcoal text-white px-8 py-4 rounded-full font-bold uppercase tracking-[0.12em] text-sm hover:bg-rc-red transition-colors";

export const BTN_OUTLINE_LIGHT =
  "inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-4 rounded-full font-bold uppercase tracking-[0.12em] text-sm hover:bg-white hover:text-rc-charcoal transition-colors";

export const BTN_OUTLINE_DARK =
  "inline-flex items-center justify-center gap-2 border-2 border-rc-charcoal text-rc-charcoal px-8 py-4 rounded-full font-bold uppercase tracking-[0.12em] text-sm hover:bg-rc-charcoal hover:text-white transition-colors";
